export interface ICustomPermission {
    id: number;
    label: string;
    accessible_by: number;
}

export class CustomPermission implements ICustomPermission {
    public id: number;
    public label: string;
    public accessible_by: number; // tslint:disable-line:variable-name

    constructor(options: {
        id?: number,
        label?: string,
        accessible_by?: number,
    } = {}) {
        this.id = options.id || null;
        this.label = options.label || '';
        this.accessible_by = options.accessible_by || null;
    }
}
